// CreateResiProperty.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CreateLand from './CreateLand';        // Import Land form component
import CreateStructure from './CreateStructure'; // Import Structure form component
import CreateLoan from "./CreateLoan";
import Modal from './components/Modal';


const CreateResiProperty = () => {
    const [description, setDescription] = useState('');
    const [totalPurchasePrice, setTotalPurchasePrice] = useState(0);
    const [purchaseDate, setPurchaseDate] = useState(null);
    const [moveInDate, setMoveInDate] = useState(null);
    const [equityFinancingAmount, setEquityFinancingAmount] = useState('');
    const [financingSourceObjects, setFinancingSourceObjects] = useState([]);
    const [selectedFinancingSourceObject, setSelectedFinancingSourceObject] = useState(null); // single selection
    const [location, setLocation] = useState('');
    const [titleDocument, setTitleDocument] = useState(null);
    const [deedLink, setDeedLink] = useState(null);
    const [error, setError] = useState('');
    const [landFormVisible, setLandFormVisible] = useState(false); // State for Land Form visibility
    const [structureFormVisible, setStructureFormVisible] = useState(false); // State for Structure Form visibility
    const [resiPropertyId, setResiPropertyId] = useState(null); // State to hold the created resi property ID
    const [isAddNewDebtVisible, setAddNewDebtVisible] = useState(false); // State for add new debt form visibility
    const [navigated, setNavigated] = useState(false); // Track if you have already navigated

    // Address state variables
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');

    const navigate = useNavigate();

    // In the useEffect, keep the fetching logic to populate financingSourceObjects
    useEffect(() => {
        const fetchFinancingSourceObjects = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/assets/physical_assets/resi_properties/mortgage-choices/');
                setFinancingSourceObjects(response.data);
                console.log('Selected Financing Source Object Data:', response.data)
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchFinancingSourceObjects();
    }, []);

    useEffect(() => {

        const userInputEquityAmount = parseFloat(equityFinancingAmount)|| 0; // Default to 0 if no equity amount

        // Use the selected object directly to get the amount
        const selectedMortgageAmount = selectedFinancingSourceObject ? parseFloat(selectedFinancingSourceObject.amount) : 0;

        // Calculate new total purchase price
        const newTotal = userInputEquityAmount + selectedMortgageAmount;
        setTotalPurchasePrice(newTotal); // Update state with new total
    }, [equityFinancingAmount, selectedFinancingSourceObject]);

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newResiPropData = {
            'asset_type_1': 'physical_asset',
            'asset_type_2': 'resi_property',
            'description': description,
            'purchase_date': purchaseDate,
            'move_in_date': moveInDate,
            'deed_link': deedLink,
            'total_financing': {
                'financing_date': purchaseDate,
                'total_equity_amount': equityFinancingAmount,
            },
            'location': location,
            'address': {
                'street_address': street,
                'city': city,
                'state': state,
                'postal_code': postalCode,
                'country': 'USA',
            },
            'asset_expense_data': {
                'expense_category': 'initial_purchase',
                'amount': totalPurchasePrice,
                'payment_date': purchaseDate,
                'expense_desc': 'Residential property purchase'
            }
        }

        // Include financing_source only if selectedFinancingSourceObject exists
        if (selectedFinancingSourceObject) {
            newResiPropData.total_financing.debt_financing_id = selectedFinancingSourceObject.id; // Add financing source if it exists
        }

        if (titleDocument) {
            newResiPropData.append('title_document', titleDocument);
        }

        try {
            const response = await axios.post('/api/balance_sheet/assets/physical_assets/resi_properties/create-resi-property/', newResiPropData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate(`/balance_sheet/assets/physical_assets/resi_properties/${response.data.id}/`);
            setResiPropertyId(response.data.id);
            // Now you can toggle visibility for land and structure forms
        } catch (error) {
            console.error('Error creating residential property:', error);
            setError('There was an error creating the property. Please check your input.');
        }
    };

    const handleTitleFileChange = (event) => {
        setTitleDocument(event.target.files[0]);
    };

    const handleLandSubmit = async (landData) => {
        if (!resiPropertyId) {
            setError('No Residential Property created. Cannot create Land.');
            return;
        }

        try {
            const response = await axios.post(`/api/balance_sheet/assets/physical_assets/resi_properties/${resiPropertyId}/add-land/`, landData);
                        console.log('Land created:', response.data);
            setLandFormVisible(false); // Hide land form after submission if desired
        } catch (error) {
            console.error('Error creating land:', error);
            setError('There was an error creating the land. Please check your input.');
        }
    };

    const handleStructureSubmit = async (structureData) => {
        if (!resiPropertyId) {
            setError('No Residential Property created. Cannot create Structure.');
            return;
        }

        try {
            const response = await axios.post(`/api/balance_sheet/assets/physical_assets/resi_properties/${resiPropertyId}/add-structure/`, structureData);
            console.log('Structure created:', response.data);
            setStructureFormVisible(false); // Hide structure form after submission if desired
        } catch (error) {
            console.error('Error creating structure:', error);
            setError('There was an error creating the structure. Please check your input.');
        }
    };

return (
        <div className="container mt-4">
            <form onSubmit={handleSubmit}>
                {/* Residential Property Details */}
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Property Description:
                    </label>
                        <input
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required
                        />

                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Purchase Date:
                    </label>
                        <input
                            type="date"
                            value={purchaseDate}
                            onChange={(e) => setPurchaseDate(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required
                        />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Move-in Date:
                    </label>
                        <input
                            type="date"
                            value={moveInDate}
                            onChange={(e) => setMoveInDate(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        />
                </div>

                <div className="form-group">
                    <label htmlFor="financing_source" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Debt Financing:
                    </label>
                    <select
                        id="financing_source"
                        name="financing_source"
                        value={selectedFinancingSourceObject || ''} // Ensure it can handle null
                        onChange={(e) => {
                            const selectedId = e.target.value;
                            const selectedMortgage = financingSourceObjects.find(source => parseInt(source.id) === parseInt(selectedId)); // Find the full object
                            setSelectedFinancingSourceObject(selectedMortgage); // Store the entire mortgage object
                            console.log('Selected Mortgage:', selectedMortgage)
                        }}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                    >
                        <option value="" disabled>Select a loan</option>
                        {financingSourceObjects.map(({ id, address, amount }) => (
                            <option key={id} value={id}>{`Mortgage - ${address} - $${amount.toLocaleString()}`}</option>
                        ))}
                    </select>
                </div>
                {/* Add New Debt Checkbox */}
                <div style={{ marginTop: '10px' }}>
                    <label style={{marginLeft: '215px'}}>
                        <input
                            type="checkbox"
                            onChange={() => setAddNewDebtVisible(!isAddNewDebtVisible)} // Toggle the visibility of the new debt form
                            style={{marginRight: '10px'}}
                        />
                        Add New Debt
                    </label>
                </div>

                {/* Conditional rendering for Add New Debt form */}
                {isAddNewDebtVisible && (
                    <CreateLoan isOpen={true} onClose={() => setAddNewDebtVisible(false)} />
                )}

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Equity Financing:
                    </label>
                        <input
                            type="text"
                            value={equityFinancingAmount} // Format to dollar string
                            onChange={(e) => setEquityFinancingAmount(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required
                        />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Total Purchase Price:
                    </label>
                        <input
                            type="text"
                            value={`$${totalPurchasePrice.toLocaleString()}`} // Format as currency
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            readOnly //  Make it read-only since dynamically calculated
                        />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Location:
                    </label>
                        <input
                            type="text"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Street Address:
                    </label>
                        <input
                            type="text"
                            value={street}
                            onChange={(e) => setStreet(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        City:
                    </label>
                        <input
                            type="text"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        State:
                    </label>
                        <input
                            type="text"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Postal Code:
                    </label>
                        <input
                            type="text"
                            value={postalCode}
                            onChange={(e) => setPostalCode(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Title Document:
                    </label>
                        <input
                            type="file"
                            onChange={handleTitleFileChange}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        />
                </div>
                <div className="form-group">
                    <label htmlFor="linkInput" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Link to Deed:
                    </label>
                    <input
                        type="url"
                        id="linkInput"
                        value={deedLink}  // This should be a state variable in your component
                        onChange={(e) => setDeedLink(e.target.value)}  // Update state on change
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                    />
                </div>

                <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
                </div>
            </form>

            {error && <div style={{ color: 'red' }}>{error}</div>} {/* Display error messages */}

            {/* Only show Land and Structure forms if the Residential Property has been created */}
            {resiPropertyId && (
                <>
                    {/* Button to toggle Land Form visibility */}
                    <button type="button" className="btn btn-secondary" onClick={() => setLandFormVisible(prev => !prev)}>
                        {landFormVisible ? "Cancel Land Form" : "Add Land"}
                    </button>
                    {landFormVisible && (
                        <Modal isOpen={true} onClose={() => setLandFormVisible(false)} title="Add Land" width={800}>
                            <CreateLand onSubmit={handleLandSubmit} />
                        </Modal>
                    )}

                    {/* Button to toggle Structure Form visibility */}
                    <button type="button" className="btn btn-secondary" onClick={() => setStructureFormVisible(prev => !prev)}>
                        {structureFormVisible ? "Cancel Structure Form" : "Add Structure"}
                    </button>
                    {structureFormVisible && (
                        <Modal isOpen={true} onClose={() => setStructureFormVisible(false)} title="Add Structure" width={800}>
                            <CreateStructure onSubmit={handleStructureSubmit} propertyId={resiPropertyId} />
                        </Modal>
                    )}
                </>
            )}
        </div>
    );
};

export default CreateResiProperty;